import React from "react";
import { Col } from "reactstrap";
import CommonInput from "../common/formFeilds/input/commonInput";

const ApprovalLevelSection = ({
  level,
  values,
  setValues,
  roleData,
  showOverall,
}) => {
  const levelKey = level.toLowerCase(); // e.g. 'l1'

  const handleChange = (key, value) => {
    if (value > 100) return;
    setValues({ ...values, [key]: value });
  };

  return (
    <div className="d-flex justify-content-between pt-2">
      <Col className="pl-0">
        <CommonInput
          type="number"
          allowDecimalvalue={true}
          mandatory={true}
          label={`Set ${level} custom upto* %`}
          defaultValue={values[`${levelKey}ApprovalPercentage`]}
          onChange={(val) => handleChange(`${levelKey}ApprovalPercentage`, val)}
          adornmentText="%"
          placeHolder="Enter"
        />
      </Col>

      {showOverall && (
        <Col className="pl-0">
          <CommonInput
            type="number"
            allowDecimalvalue={true}
            mandatory={true}
            label={`Set ${level} overall subject to* %`}
            defaultValue={values[`${levelKey}ApprovalOverAllPercentage`]}
            onChange={(val) =>
              handleChange(`${levelKey}ApprovalOverAllPercentage`, val)
            }
            adornmentText="%"
            placeHolder="Enter"
          />
        </Col>
      )}

      <Col className="pl-0">
        <CommonInput
          type="multiSelectWithCheckboxes"
          mandatory={true}
          label={`${level} Role`}
          defaultValue={values[`${levelKey}ApprovalRoles`]}
          onChange={(val) =>
            setValues({ ...values, [`${levelKey}ApprovalRoles`]: val })
          }
          data={roleData.data}
        />
      </Col>
    </div>
  );
};

export const ApprovalSetting = ({
  roleData,
  values,
  setValues,
  isRegularCharges = false,
}) => {
  return (
    <div
      style={{
        border: "1px solid #EDEDED",
        padding: "16px 24px",
        borderRadius: "12px",
        marginTop: 10,
      }}
    >
      <div className="semi-bold label-color">2. Approval setting</div>

      {/* <div className="d-flex pt-2">
        <Col className="pl-0">
          <CommonInput
            type="number"
            allowDecimalvalue={true}
            mandatory={true}
            defaultValue={values.l1MaxCapping}
            label="Set max capping %"
            onChange={(value) => {
              if (value > 100) return;
              setValues({ ...values, l1MaxCapping: value });
            }}
            adornmentText="%"
            placeHolder="Enter"
          />
        </Col>
        <Col />
      </div> */}

      {/* Reusable Sections */}
      {["L1", "L2", "L3"].map((level) => (
        <ApprovalLevelSection
          key={level}
          level={level}
          values={values}
          setValues={setValues}
          roleData={roleData}
          showOverall={isRegularCharges}
        />
      ))}
    </div>
  );
};
